webpackJsonp([1,2],{

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter__);
/* unused harmony export gebHandler */
/* unused harmony export bus */




var gebus = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__["Subject"]();
var geb = {};
var gebInstance = {
  getBus: function getBus() {
    return gebus;
  },
  emit: function emit(obj) {
    gebus.next(obj);
  },
  getFilteredBus: function getFilteredBus(arg) {
    if (!isObject(arg)) {
      throw new Error("data provided to geb().filterBy() isn't an object");
    }
    return gebus.filter(function (gebItem) {
      var flag = true;
      var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(arg);
      props.forEach(function (prop) {
        if (gebItem[prop] !== arg[prop]) {
          flag = false;
        }
      });
      return flag;
    });
  }
};

geb.install = function (Vue, options) {
  Vue.directive('geb-click-emit', {
    componentUpdated: function componentUpdated(el, binding) {},
    inserted: function inserted(el, binding) {
      el.addEventListener('click', function (event) {
        gebus.next(binding.value);
      });
    }
  });
  Vue.directive('geb-keyupenter-emit', {
    componentUpdated: function componentUpdated(el, binding) {},
    inserted: function inserted(el, binding) {
      el.addEventListener('keypress', function (e) {
        var key = e.which || e.keyCode;
        if (key === 13) {
          gebus.next(binding.value);
        }
      });
    }
  });
  Vue.prototype.$geb = gebInstance;
};

function isObject(obj) {
  return obj === Object(obj);
}

/* harmony default export */ __webpack_exports__["a"] = geb;

var gebHandler = gebInstance;
var bus = gebus;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(56)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(78),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_logAllComponent_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_logAllComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_logAllComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_logIdComponent_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_logIdComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_logIdComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sendToBusComponent_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sendToBusComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sendToBusComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_simpleToBus_vue__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_simpleToBus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_simpleToBus_vue__);








/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    Hello: __WEBPACK_IMPORTED_MODULE_0__components_Hello___default.a,
    LogAll: __WEBPACK_IMPORTED_MODULE_1__components_logAllComponent_vue___default.a,
    LogId: __WEBPACK_IMPORTED_MODULE_2__components_logIdComponent_vue___default.a,
    ToBus: __WEBPACK_IMPORTED_MODULE_3__components_sendToBusComponent_vue___default.a,
    SimpleToBus: __WEBPACK_IMPORTED_MODULE_4__components_simpleToBus_vue___default.a
  }
};

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
};

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = {
  created: function created() {
    var _this = this;

    this._sub = this.$geb.getBus().subscribe(function (data) {
      _this.logs.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    });
  },
  destroyed: function destroyed() {
    if (this._sub) {
      this._sub.unsubscribe();
    }
  },
  data: function data() {
    return {
      logs: []
    };
  }
};

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["default"] = {
  created: function created() {
    var _this = this;

    this._sub = this.$geb.getFilteredBus({ id: this.selector }).subscribe(function (data) {
      _this.logs.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    });
  },
  destroyed: function destroyed() {
    if (this._sub) {
      this._sub.unsubscribe();
    }
  },
  data: function data() {
    return {
      logs: []
    };
  },

  props: ['selector']
};

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'tobus',
  data: function data() {
    return {
      target: '',
      payload: ''
    };
  },

  methods: {
    sendToBus: function sendToBus() {
      this.$geb.emit({ id: this.target, payload: this.payload });
    }
  }
};

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'simpletobus',
  data: function data() {
    return {
      payload: ''
    };
  },

  methods: {
    sendToBus: function sendToBus() {
      this.$geb.emit({ data: this.payload });
    }
  }
};

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(59)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(81),
  /* scopeId */
  "data-v-41dde93d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(58)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(57)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(79),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(61)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(83),
  /* scopeId */
  "data-v-aa531584",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 78:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('LogAll'), _vm._v(" "), _c('h1', [_vm._v("Vue-geb plugin example")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("Emit to the GEB Stream")]), _vm._v(" "), _c('h3', [_vm._v("Directive: ")]), _vm._v(" "), _c('ul', [_c('li', [_c('button', {
    directives: [{
      name: "geb-click-emit",
      rawName: "v-geb-click-emit",
      value: ({
        foo: 'bar'
      }),
      expression: "{foo:'bar'}"
    }]
  }, [_vm._v("Send")])])]), _vm._v(" "), _c('h3', [_vm._v("Methods")]), _vm._v(" "), _c('ul', [_c('li', [_c('SimpleToBus')], 1)]), _vm._v(" "), _c('h3', [_vm._v("Get only specific events")]), _vm._v(" "), _c('ToBus'), _vm._v(" "), _c('LogId', {
    attrs: {
      "selector": "foo"
    }
  }), _vm._v(" "), _c('LogId', {
    attrs: {
      "selector": "bar"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/vouill/vue-geb"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "border": "0",
      "z-index": "1000"
    },
    attrs: {
      "src": "https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67",
      "alt": "Fork me on GitHub",
      "data-canonical-src": "https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The Global Event Bus (GEB) is accessible to every Vue component."), _c('br'), _vm._v("\n      From any component you can emit or receive data from the GEB.")])
}]}

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tobus"
  }, [_c('div', [_c('ul', [_c('li', [_c('label', [_vm._v("Target: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.target),
      expression: "target"
    }],
    attrs: {
      "placeholder": "'foo' or 'bar'"
    },
    domProps: {
      "value": _vm._s(_vm.target)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.sendToBus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.target = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', [_vm._v("Payload: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payload),
      expression: "payload"
    }],
    attrs: {
      "placeholder": "Anything you want"
    },
    domProps: {
      "value": _vm._s(_vm.payload)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.sendToBus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payload = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.sendToBus()
      }
    }
  }, [_vm._v("Send")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logAll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "logArea"
  }, [_c('ul', {
    staticClass: "noListStyle"
  }, _vm._l((_vm.logs.slice().reverse()), function(log) {
    return _c('li', [_vm._v(_vm._s(log))])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_c('strong', [_vm._v("Bus Data Stream:")])])])
}]}

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('p', [_vm._v("This is a basic example of a vue-plugin.")])])
},staticRenderFns: []}

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logId"
  }, [_c('div', [_c('p', [_vm._v("Component with prop "), _c('br'), _vm._v(" selector: '"), _c('strong', [_vm._v(_vm._s(this.selector))]), _vm._v("'")])]), _vm._v(" "), _c('div', {
    staticClass: "logArea"
  }, [_c('ul', {
    staticClass: "noListStyle"
  }, _vm._l((_vm.logs.slice().reverse()), function(log) {
    return _c('li', [_vm._v(_vm._s(log))])
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toBus"
  }, [_c('ul', {
    staticClass: "noListStyle"
  }, [_c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payload),
      expression: "payload"
    }],
    attrs: {
      "placeholder": "Anything you want"
    },
    domProps: {
      "value": _vm._s(_vm.payload)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.sendToBus()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payload = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.sendToBus()
      }
    }
  }, [_vm._v("Send")])])])
},staticRenderFns: []}

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugin_plugin__ = __webpack_require__(18);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2__plugin_plugin__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })

},[85]);


// WEBPACK FOOTER //
// static/js/app.js